import { ClickAwayListener } from "@mui/material";
import { useState, useTransition } from "react";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "../../common/Buttons";

const CasesDropdownMenu = ({
  handleSubmit,
  list,
  selectedValue = null,
  handleClose,
}) => {
  const [selectedList, setSelectedList] = useState(
    (selectedValue && list.filter((el) => selectedValue.includes(el.id))) || []
  );
  const { t } = useTranslation();
  const addSelection = (item) =>
    setSelectedList((pre) => {
      return [...pre, item];
    });
  const removeSelection = (item) =>
    setSelectedList((pre) => pre.filter((el) => el.id !== item.id));
  const alreadyExist = (id) => selectedList.some((el) => el.id === id);
  const handleSelection = (item) => {
    if (!alreadyExist(item.id)) {
      addSelection(item);
    } else {
      removeSelection(item);
    }
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className="cases-dropdown-menu" boxShadow={5}>
        <li
          className={`entire-cases ${selectedValue === null && "active"}`}
          onClick={() => {
            setSelectedList([]);
            selectedValue !== null && handleSubmit(null);
          }}
        >
          <p>{t("see-entire-cases")}</p>
        </li>
        <h5 className="menu-heading">{t("advisor's-name")}</h5>
        <ul>
          {list?.map((item) => (
            <li
              key={item.id}
              className={alreadyExist(item?.id) && "active"}
              onClick={(e) => {
                e.stopPropagation();
                handleSelection(item);
              }}
            >
              <p>{item.name}</p>
            </li>
          ))}
        </ul>
        <div className="action-button">
          <PrimaryButton
            title="Show the results"
            fullWidth
            click={() => handleSubmit(selectedList)}
            padding="8px 10px"
            // size="small"
            fontSize="11px"
            fontWeight="400 !important"
            width={"100%"}
          />
        </div>
      </div>
    </ClickAwayListener>
  );
};

export default CasesDropdownMenu;
